import { GetExceptionLogDetailsRequest, GetExceptionLogDetailsResponse } from '../fragments';
import { apiGet } from 'api/utils';

export const getExceptionLogDetails = (
  request: GetExceptionLogDetailsRequest
): Promise<GetExceptionLogDetailsResponse> =>
  apiGet<GetExceptionLogDetailsResponse, GetExceptionLogDetailsRequest>(
    `exceptions/${request.exceptionLogType}/${request.exceptionId}/`
  );
